export default __webpack_public_path__ + "static/media/b11.9356d949.png";